<template>
  <div class="h-full">
    <!-- <div class="flex mb-10px pt-10px mr-10px">
      <el-button size="small" type="primary" @click="formDialog = true" v-loading="loading"
        >添加人员</el-button
      >
    </div> -->
    <el-table
      ref="table"
      :data="tableData"
      class="w-full"
      :height="tableHeight"
      v-loading="loading"
    >
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column label="人员名称" prop="userName" show-overflow-tooltip />
      <el-table-column label="应急组织" prop="emgOrganizationText" show-overflow-tooltip />
      <el-table-column label="部门" prop="departmentsText" show-overflow-tooltip />
      <el-table-column label="岗位" prop="postsText" show-overflow-tooltip />
      <!-- <el-table-column label="定位状态" prop="suppliesSiteName" show-overflow-tooltip />
        <el-table-column label="所属区域" prop="areaName" show-overflow-tooltip /> -->
      <el-table-column label="联系方式" prop="contact" show-overflow-tooltip />
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click.native="deleteRow(scope.row.userId)">删除</el-button> -->
          <span class="text-rose-500 mr-10px cursor-pointer" @click="deleteRow(scope.row.userId)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <RescueSchedulingDialog
      v-if="formDialog"
      :dataList="tableData"
      @cancel="formDialog = false"
      @handleOk="handleOk"
    ></RescueSchedulingDialog>
  </div>
</template>

<script>
import RescueSchedulingDialog from './RescueSchedulingDialog'

export default {
  name: 'rescue-scheduling-table',
  components: {
    RescueSchedulingDialog,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formDialog: false,
      tableData: [],
      loading: false,
      total: 0,
    }
  },
  watch: {},
  computed: {
    tableHeight() {
      return 'calc(100% - 80px)'
    },
  },
  created() {
    this.findList()
  },
  mounted() {},
  methods: {
    handleOk(list) {
      this.tableData = [...this.tableData, ...list]
    },
    deleteRow(userId) {
      this.tableData = this.tableData.filter((item) => {
        return item.userId !== userId
      })
    },

    async findList() {
      // const data = {
      //   riskPointType: 0,
      //   maxResultCount: this.pageConfig.MaxResultCount,
      //   skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount,
      //   ...this.searchData,
      // }
      // this.loading = true
      // const [err, res] = await sourcesDangerRecognitionPlanTaskApi.riskPointPagedListQuery(data)
      // if (!err) {
      //   this.tableData = res.items.map((item) => {
      //     item.id = item.riskPointId
      //     item.jobName = item.riskPointName
      //     return item
      //   })
      //   this.total = res.totalCount
      // }
      // this.loading = false
    },
  },
}
</script>

<style></style>
